import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SwiperGameSchedule"] */ "/opt/buildhome/repo/src/app/_components/SectionGameSchedule/SwiperGameSchedule/SwiperGameSchedule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwiperNews"] */ "/opt/buildhome/repo/src/app/_components/SectionNews/SwiperNews/SwiperNews.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/css/splide.css");
;
import(/* webpackMode: "eager", webpackExports: ["VideoComponent"] */ "/opt/buildhome/repo/src/components/elements/video/index.tsx");
